// extracted by mini-css-extract-plugin
export var background = "Footer-module--background--91641";
export var button = "Footer-module--button--d9f3e";
export var center = "Footer-module--center--14b52";
export var contact = "Footer-module--contact--d8d4f";
export var container = "Footer-module--container--c55ec";
export var decor = "Footer-module--decor--6fa06";
export var footerWrapper = "Footer-module--footerWrapper--c565c";
export var left = "Footer-module--left--e6233";
export var lineAbove = "Footer-module--lineAbove--dfccd";
export var programs = "Footer-module--programs--5968d";
export var relativeWrapper = "Footer-module--relativeWrapper--4b3b2";
export var right = "Footer-module--right--49435";
export var social = "Footer-module--social--f662a";